import { render } from "./registry.vue?vue&type=template&id=ba224fd8"
import script from "./registry.vue?vue&type=script&lang=js"
export * from "./registry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__